<template>

<div>

    <div v-if='timecardData' class='container' id='timecard-data'>
        <div v-if='timecardData.clock_out' class='timecard-title'>
            Clocked out 
        </div>
        <div v-else class='timecard-title'>
            Clocked in 
        </div>

        <div class='timecard-user'>
            {{ timecardData.user.name }}
        </div>
        <div class='timecard-usercode'>
            {{ timecardData.user.code }}
        </div>

        <div v-if='timecardData.clock_out' class='timecard-datetime'>
            <div class='timecard-date'>
                {{ timecardData.clock_out.toFormat( 'LLLL dd, yyyy' ) }}
            </div>
            <div class='timecard-time'>
                {{ timecardData.clock_out.toFormat( 'hh:mm a' ) }}
            </div>
        </div>
        <div v-else class='timecard-datetime'>
            <div class='timecard-date'>
                {{ timecardData.clock_in.toFormat( 'LLLL dd, yyyy' ) }}
            </div>
            <div class='timecard-time'>
                {{ timecardData.clock_in.toFormat( 'hh:mm a' ) }}
            </div>
        </div>

        <div v-if='timecardData.clock_out'>
            <div class='timecard-summary'>Time worked: {{ timecardData.hours_worked }}</div>
            <div class='timecard-summary'>Accumulated: {{ timecardData.accumulated_hours }}</div>
        </div>

        <div class='back-button-container'>
            <button @click='backToKeypad' class='back-button'>Back</button>
        </div>

    </div>

    <div v-else class='container clockin-container'>

        <div id='title'>
            Clocker
        </div>

        <div id='location-select-container'>
            <select id='location-select' placeholder='Select a location' v-model="selectedLocation">
                <option v-for='location in locations' :key='location.id' :value='location.id'>{{ location.name }}</option>
            </select>
        </div>

        <div id='user-input'>{{ input }}</div>

        <div id='error-container'>{{ error }}</div>

        <button class='keypad-btn' @click='enterNumber(1)'>1</button>
        <button class='keypad-btn' @click='enterNumber(2)'>2</button>
        <button class='keypad-btn' @click='enterNumber(3)'>3</button>
        <button class='keypad-btn' @click='enterNumber(4)'>4</button>
        <button class='keypad-btn' @click='enterNumber(5)'>5</button>
        <button class='keypad-btn' @click='enterNumber(6)'>6</button>
        <button class='keypad-btn' @click='enterNumber(7)'>7</button>
        <button class='keypad-btn' @click='enterNumber(8)'>8</button>
        <button class='keypad-btn' @click='enterNumber(9)'>9</button>
        <button class='keypad-btn' @click='clearNumber()'>Clear</button>
        <button class='keypad-btn' @click='enterNumber(0)'>0</button>
        <button class='keypad-btn' @click='submitNumber()'>
            <div v-if="isLoading">
                <BarLoader/>
            </div>
            <span v-else>Enter</span>
        </button>
    </div>
</div>

</template>

<script>
import Vue from 'vue'
import LocationService from '../locations/LocationService';
import BarLoader from '../shared/loaders/bar/BarLoader.vue';
import { DateTime } from 'luxon';

export default {
    data: () => ({
        input: '',
        locationService: new LocationService(),
        locations: [],
        selectedLocation: null,
        error: '',
        timecardData: null,
        isLoading: false,
    }),
    components: { BarLoader },
    methods: {
        enterNumber( val ) {
            this.input += val;
        },

        clearNumber() {
            this.input = '';
            this.error = '';
        },

        submitNumber() {
            if (this.isLoading) {return;}

            this.error = "";
            localStorage.setItem( 'selectedLocation', this.selectedLocation )

            if ( this.selectedLocation == null ) {
                this.error = "Please select a location before clocking in";
                return;
            }

            if ( this.input.length < 4 ) {
                this.error = "Please enter a valid code";
                return;
            }

            this.isLoading = true;
            Vue.http.post( 'punch', {
                code: this.input,
                location_id: this.selectedLocation,
                time: DateTime.local().toFormat( "yyyy-LL-dd'T'HH:mm:ss" )
            } ).then(
                response => {
                    this.timecardData = response.body.data
                
                    this.timecardData.clock_in = new DateTime( this.timecardData.clock_in )
                    if ( this.timecardData.clock_out ) {
                        this.timecardData.clock_out = new DateTime( this.timecardData.clock_out )
                    }
                },
                err => {
                    console.log( err )
                    this.error = "A server error has occured. Please try again."
                }
            )
            .finally(() => this.isLoading = false)
        },

        backToKeypad() {
            this.timecardData = null
            this.input = ''
        }
    },

    created() {
        this.locationService.list().then(
            response => {
                this.locations = response.body.data;
                this.locationsLoaded = true;

                localStorage.setItem( 'locations', this.locations )

                if ( localStorage.getItem( 'selectedLocation' ) ) {
                    this.selectedLocation = localStorage.getItem( 'selectedLocation' )
                }
            }
        )
    }
    
}
</script>


<style lang="less">

body {
    background-color: rgb( 247, 247, 247 );
    font-size: 1.1em;
}

.clockin-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(8, auto);
    gap: 10px;
    height: 100vh;
    padding: 20px 0;
}

#title {
    font-size: 2.8em;
    text-align: center;
    grid-column-start: 1;
    grid-column-end: span 3;
}

#location-select-container {
    grid-column-start: 1;
    grid-column-end: span 3;
    display: flex;
    align-items: center;

    #location-select {
        width: 100%;
        padding: 4px 8px;
    }
}

#user-input {
    font-size: 2.8rem;
    align-items: center;
    justify-content: center;
    display: flex;
    min-height: 2.8rem;
    grid-column-start: 1;
    grid-column-end: span 3;
}

#error-container {
    color: rgb( 153, 30, 30 );
    font-size: 1.8em;
    text-align: center;
    grid-column-start: 1;
    grid-column-end: span 3;
}

.keypad-btn {
    display: flex;
    border: 1px solid rgb( 240, 240, 240 );
    box-shadow: 0 2px 6px rgba( 150, 150, 150, 0.2 );
    font-size: 1.25em;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 40px;

    background-color: white;
    user-select: none;
}

.keypad-btn:hover {
    background-color: rgb( 240, 240, 240 );
}

.keypad-btn:active {
    background-color: rgb( 220, 220, 220 );
}

#timecard-data {
    text-align: center;

    .timecard-title {
        font-size: 4em;
        margin: 20px 0;
        font-weight: bold;
    }

    .timecard-user {
        margin: 40px 0 8px 0;   
    }

    .timecard-usercode {
        margin-bottom: 40px;
    }

    .timecard-date {
        font-size: 2.5em;
        margin-bottom: 10px;
    }

    .timecard-time {
        font-size: 3em;
        margin-bottom: 20px;
    }

    .back-button-container {
        margin-top: 30px;
        display: flex;
        justify-content: center;

        .back-button {
            min-width: 100px;
            padding: 8px 0;
            margin-top: 10px;
            background-color: #74b9ff;
        }

    }
}

</style>